import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import ChildEventStore from "./Components/ChildEventStore";
import { MyContext } from "./State/ProviderData";
import BorderColorIcon from "@material-ui/icons/BorderColor";
import { isLoggedIn } from "./Auth/auth";

export const EpreuvesList2 = (props) => {
  const { epreuves } = props;
  //localStorage.clear();
  const [myData, setMyData] = useContext(MyContext);
  const [basket, setBasket] = useState(myData);
  const [keyRefresh, setKeyRefresh] = useState(new Date());

  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem("basket"));
    if (storedData && storedData != null) {
      setBasket(storedData);
    }
  }, []);

  useEffect(() => {
    if (basket) {
      localStorage.setItem(
        "basket",
        JSON.stringify(basket.filter((e) => e != null)),
        null
      );
      setKeyRefresh(new Date());
      setMyData(basket);
    }
  }, [basket]);

  const addEvent = (epreuve) => {
    setBasket((prevData) => [
      ...prevData,
      { id: epreuve.id, name: epreuve.name_event },
    ]);
  };

  const removeEvent = (epreuve) => {
    setBasket((prevData) =>
      prevData.filter((e) => e != null).filter((item) => item.id !== epreuve.id)
    );
  };

  return epreuves ? (
    <div className="w-100">
      {epreuves.map((epreuve, index) => (
        <div className="row" key={index}>
          <div className={props.remove ? "col-md-11" : "col-md-12"}>
            <Link
              to={`${process.env.PUBLIC_URL}/epreuve/${epreuve.id}?${
                epreuve.name_event
              }&filter${epreuve.date.slice(-13, -9)}`}
              className="text-dark text-decoration-none itemTri"
              key={keyRefresh}
            >
              <div
                className="row border mb-2 rounded hoverCardColor"
                key={epreuve.id + epreuve.name_event}
                style={{ height: "auto", width: "100%" }}
              >
                <div className="col-lg-2 col-12 media-content">
                  {epreuve.date.slice(0, 10)}
                </div>
                <div className="col-lg-5 col-12 media-content font-weight-bold pl-md-4">
                  {epreuve.name_event}
                </div>
                <div className="col-md-3 col-12 media-content">
                  {epreuve.city} ({epreuve.department})
                </div>
                <div className="col-lg-2 col-12 media-content p-0 border border-warning">
                  {epreuve.races.map((item, idx) => (
                    <span
                      className="my-auto py-auto px-2 w-100 h-100"
                      key={item.type_triathlon + item.name_race + idx}
                    >
                      {item.type_triathlon + " "}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          </div>
          {props.remove === true ? (
            <div className="col-md-1 col-12 media-content">
              <ChildEventStore
                epreuve={epreuve}
                addEvent={addEvent}
                removeEvent={removeEvent}
              />
              <Link
                to={{
                  pathname: `${process.env.PUBLIC_URL}/epreuves/update`,
                  state: { eventRef: epreuve },
                }}
              >
                {isLoggedIn() ? (
                  <BorderColorIcon className="mx-auto d-block text-warning w-50" />
                ) : null}
              </Link>
            </div>
          ) : null}
        </div>
      ))}
    </div>
  ) : null;
};



// import React, { useState, useContext } from "react";
// import { Link, useLocation } from "react-router-dom";
// import { Helmet } from "react-helmet-async";

// import ChildEventStore from "./Components/ChildEventStore";
// import { MyContext } from "./State/ProviderData";
// import BorderColorIcon from "@material-ui/icons/BorderColor";
// import { isLoggedIn } from "./Auth/auth";

// export const EpreuvesList2 = ({ epreuves, remove }) => {
//   const [myData, setMyData] = useContext(MyContext);
//   const [basket, setBasket] = useState(myData);

//   const location = useLocation();
//   const currentPath = location.pathname;

//   // ================== Functions ==================
//   const addEvent = (epreuve) => {
//     setBasket((prevData) => [
//       ...prevData,
//       { id: epreuve.id, name: epreuve.name_event },
//     ]);
//     setMyData([...basket, { id: epreuve.id, name: epreuve.name_event }]);
//   };

//   const removeEvent = (epreuve) => {
//     const newBasket = basket.filter((item) => item?.id !== epreuve.id);
//     setBasket(newBasket);
//     setMyData(newBasket);
//   };

//   // ================== SEO Dynamic ==================
//   const pageTitle =
//     currentPath === "/"
//       ? "Calendrier des triathlons en France | XL Tri"
//       : `Épreuve ${epreuves?.[0]?.name_event || ""} | XL Triathlon`;

//   const pageDescription =
//     currentPath === "/"
//       ? "Découvrez le calendrier complet des triathlons en France : dates, lieux, formats et inscriptions aux épreuves."
//       : `Informations sur l'épreuve ${epreuves?.[0]?.name_event}, ${epreuves?.[0]?.city || ""} (${epreuves?.[0]?.department || ""}).`;

//   // ================== Render ==================
//   return epreuves && epreuves.length > 0 ? (
//     <>
//       <Helmet>
//         <title>{pageTitle}</title>
//         <meta name="description" content={pageDescription} />
//         <link
//           rel="canonical"
//           href={`https://calendrier.xl-triathlon.fr${currentPath}`}
//         />
//       </Helmet>

//       <div className="w-100">
//         <h1 className="mb-4">
//           {currentPath === "/"
//             ? "Calendrier des épreuves de triathlon en France"
//             : epreuves?.[0]?.name_event}
//         </h1>

//         {epreuves.map((epreuve, index) => (
//           <div className="row" key={index}>
//             <div className={remove ? "col-md-11" : "col-md-12"}>
//               <Link
//                 to={`/epreuve/${epreuve.id}?${epreuve.name_event}&filter${epreuve.date.slice(
//                   -13,
//                   -9
//                 )}`}
//                 className="text-dark text-decoration-none itemTri"
//               >
//                 <article
//                   className="row border mb-2 rounded hoverCardColor"
//                   style={{ height: "auto", width: "100%" }}
//                 >
//                   <div className="col-lg-2 col-12">{epreuve.date.slice(0, 10)}</div>
//                   <div className="col-lg-5 col-12 font-weight-bold pl-md-4">
//                     {epreuve.name_event}
//                   </div>
//                   <div className="col-md-3 col-12">
//                     {epreuve.city} ({epreuve.department})
//                   </div>
//                   <div className="col-lg-2 col-12 p-0 border border-warning">
//                     {epreuve.races.map((item, idx) => (
//                       <span
//                         className="px-2"
//                         key={item.type_triathlon + item.name_race + idx}
//                       >
//                         {item.type_triathlon}
//                       </span>
//                     ))}
//                   </div>
//                 </article>
//               </Link>
//             </div>

//             {remove && (
//               <div className="col-md-1 col-12">
//                 <ChildEventStore
//                   epreuve={epreuve}
//                   addEvent={addEvent}
//                   removeEvent={removeEvent}
//                 />

//                 {isLoggedIn() && (
//                   <Link
//                     to={{
//                       pathname: "/epreuves/update",
//                       state: { eventRef: epreuve },
//                     }}
//                   >
//                     <BorderColorIcon className="mx-auto d-block text-warning w-50" />
//                   </Link>
//                 )}
//               </div>
//             )}
//           </div>
//         ))}
//       </div>
//     </>
//   ) : null;
// };


// // import React, { useState, useEffect, useContext } from "react";
// // import { Link } from "react-router-dom";
// // import ChildEventStore from "./Components/ChildEventStore";
// // import { MyContext } from "./State/ProviderData";
// // import BorderColorIcon from "@material-ui/icons/BorderColor";
// // import { isLoggedIn } from "./Auth/auth";

// // export const EpreuvesList2 = (props) => {
// //   const { epreuves } = props;
// //   //localStorage.clear();
// //   const [myData, setMyData] = useContext(MyContext);
// //   const [basket, setBasket] = useState(myData);
// //   const [keyRefresh, setKeyRefresh] = useState(new Date());

// //   useEffect(() => {
// //     const storedData = JSON.parse(localStorage.getItem("basket"));
// //     if (storedData && storedData != null) {
// //       setBasket(storedData);
// //     }
// //   }, []);

// //   useEffect(() => {
// //     if (basket) {
// //       localStorage.setItem(
// //         "basket",
// //         JSON.stringify(basket.filter((e) => e != null)),
// //         null
// //       );
// //       setKeyRefresh(new Date());
// //       setMyData(basket);
// //     }
// //   }, [basket]);

// //   const addEvent = (epreuve) => {
// //     setBasket((prevData) => [
// //       ...prevData,
// //       { id: epreuve.id, name: epreuve.name_event },
// //     ]);
// //   };

// //   const removeEvent = (epreuve) => {
// //     setBasket((prevData) =>
// //       prevData.filter((e) => e != null).filter((item) => item.id !== epreuve.id)
// //     );
// //   };

// //   return epreuves ? (
// //     <div className="w-100">
// //       {epreuves.map((epreuve, index) => (
// //         <div className="row" key={index}>
// //           <div className={props.remove ? "col-md-11" : "col-md-12"}>
// //             <Link
// //               to={`/epreuve/${epreuve.id}?${
// //                 epreuve.name_event
// //               }&filter${epreuve.date.slice(-13, -9)}`}
// //               className="text-dark text-decoration-none itemTri"
// //               key={keyRefresh}
// //             >
// //               <div
// //                 className="row border mb-2 rounded hoverCardColor"
// //                 key={epreuve.id + epreuve.name_event}
// //                 style={{ height: "auto", width: "100%" }}
// //               >
// //                 <div className="col-lg-2 col-12 media-content">
// //                   {epreuve.date.slice(0, 10)}
// //                 </div>
// //                 <div className="col-lg-5 col-12 media-content font-weight-bold pl-md-4">
// //                   {epreuve.name_event}
// //                 </div>
// //                 <div className="col-md-3 col-12 media-content">
// //                   {epreuve.city} ({epreuve.department})
// //                 </div>
// //                 <div className="col-lg-2 col-12 media-content p-0 border border-warning">
// //                   {epreuve.races.map((item, idx) => (
// //                     <span
// //                       className="my-auto py-auto px-2 w-100 h-100"
// //                       key={item.type_triathlon + item.name_race + idx}
// //                     >
// //                       {item.type_triathlon + " "}
// //                     </span>
// //                   ))}
// //                 </div>
// //               </div>
// //             </Link>
// //           </div>
// //           {props.remove === true ? (
// //             <div className="col-md-1 col-12 media-content">
// //               <ChildEventStore
// //                 epreuve={epreuve}
// //                 addEvent={addEvent}
// //                 removeEvent={removeEvent}
// //               />
// //               <Link
// //                 to={{
// //                   pathname: "/epreuves/update",
// //                   state: { eventRef: epreuve },
// //                 }}
// //               >
// //                 {isLoggedIn() ? (
// //                   <BorderColorIcon className="mx-auto d-block text-warning w-50" />
// //                 ) : null}
// //               </Link>
// //             </div>
// //           ) : null}
// //         </div>
// //       ))}
// //     </div>
// //   ) : null;
// // };
